import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Provider } from 'react-redux'
import { Router, Route, useRouterHistory } from 'react-router'
import { createHistory } from 'history'
import { syncHistoryWithStore } from 'react-router-redux'

import configureStore from './store/configureStore'

import App from './containers/App'
import EsdpMap from './containers/EsdpMap'
import Topic from './containers/Topic'
import { ThemeProvider } from 'styled-components'
import theme from './components/common/theme'

export default class Esdp extends Component {
  render() {
    // set up routing
    const routeName = this.props.baseRoute
    const pathLocation = window.location.pathname.indexOf(routeName)
    const routeRoot = window.location.pathname.slice(
      0,
      pathLocation + routeName.length
    )
    const routedHistory = useRouterHistory(createHistory)({
      basename: routeRoot
    })

    // set up store
    const preloadedState =
      this.props.preloadedState ||
      (window && window.hwPreloadedState) ||
      hwPreloadedState ||
      {} // eslint-disable-line
    const store = configureStore(routedHistory, preloadedState)

    const history = syncHistoryWithStore(routedHistory, store)

    return (
      <ThemeProvider theme={theme.defaultTheme}>
        <Provider store={store}>
          <Router history={history}>
            <Route path="/" component={App}>
              <Route path="/mock">
                <Route path=":mapId/:localization" component={EsdpMap}>
                  <Route path=":topicId" component={Topic} />
                </Route>
              </Route>
              <Route path=":mapId/:localization" component={EsdpMap}>
                <Route path=":topicId" component={Topic} />
              </Route>
            </Route>
          </Router>
        </Provider>
      </ThemeProvider>
    )
  }
}

Esdp.propTypes = {
  baseRoute: PropTypes.string.isRequired,
  preloadedState: PropTypes.shape({
    prescriptionInfo: PropTypes.shape({
      consumerId: PropTypes.string,
      prescriptionId: PropTypes.string,
      contentItemId: PropTypes.string,
      parent: PropTypes.string,
      mediaServiceUrl: PropTypes.string,
      mediaToken: PropTypes.string,
      mediaHash: PropTypes.string,
      token: PropTypes.string,
      localization: PropTypes.string,
      applicationUrl: PropTypes.string,
      resourcesRoot: PropTypes.string
    }),
    serviceInfo: PropTypes.shape({
      isMocked: PropTypes.bool,
      token: PropTypes.string,
      contentServiceUrl: PropTypes.string,
      consumerServiceUrl: PropTypes.string,
      atomicFireballServiceUrl: PropTypes.string,
      notificationServiceUrl: PropTypes.string
    })
  })
}

Esdp.defaultProps = {
  baseRoute: '/'
}



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/index.js